module.exports = __webpack_public_path__ + "static/media/left-leaf.2e4922af.webp";